var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98828 7.5V14.5161H6.04941V9.43548H8.95264V14.5161H13.0138V7.5H1.98828Z",
    fill: "#2F47BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3994 3.15435L7.87016 0H7.12984L1.60065 3.15435L0 7.16516V7.98387H12.5289V14.0323H9.43548V8.95161H5.56452V14.0323H2.47113V8.95161H1.50339V15H6.53226V9.91935H8.46774V14.0323H7.5V15H13.4966V7.98387H15V7.16516L13.3994 3.15435ZM1.10129 7.01613L2.37387 3.82718L7.38629 0.967742H7.61371L12.6261 3.82718L13.8987 7.01613H1.10129Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.15243bd86a3ab69aae8733a816e08583.svg";
export { ForwardRef as ReactComponent };